import { z } from 'zod';

export const demoStatusSchema = z.object({
  enabled: z.boolean(),
  currentSitePhaseCode: z.string().nullable(),
  availablePhaseCodes: z.array(z.string()),
});

export const demoResetInputSchema = z.object({
  /**
   * Code de phase cible. Si null/undefined, on revient à un état "phase 0" (base
   * vidée hormis les tables fonctionnelles : le wizard de setup sera de nouveau actif).
   */
  phaseCode: z.string().min(1).max(64).nullable().optional(),
});

export const demoResetResponseSchema = z.object({
  ok: z.literal(true),
  resetTo: z.string().nullable(),
});

export const demoPrefillInputSchema = z.object({
  /**
   * Code identifiant le contexte de pré-remplissage (ex. "company-form", "site-form").
   * Permet à un même endpoint de servir plusieurs formulaires.
   */
  context: z.string().min(1).max(64),
  /**
   * Si false (défaut) : retourne un payload prêt à injecter côté front (mode "front-only").
   * Si true : crée réellement les entités côté API (mode "back-create").
   */
  create: z.boolean().optional().default(false),
});

export const demoPrefillResponseSchema = z.object({
  context: z.string(),
  created: z.boolean(),
  /** Données prêtes à être posées dans un formulaire react-hook-form ou créées par l'API. */
  data: z.record(z.unknown()),
});

export const demoSeedProcessCartographyResponseSchema = z.object({
  ok: z.literal(true),
  created: z.boolean(),
  message: z.string(),
});

export type DemoStatus = z.infer<typeof demoStatusSchema>;
export type DemoResetInput = z.infer<typeof demoResetInputSchema>;
export type DemoResetResponse = z.infer<typeof demoResetResponseSchema>;
export type DemoPrefillInput = z.infer<typeof demoPrefillInputSchema>;
export type DemoPrefillResponse = z.infer<typeof demoPrefillResponseSchema>;
export type DemoSeedProcessCartographyResponse = z.infer<
  typeof demoSeedProcessCartographyResponseSchema
>;
